import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { type AuthorizedUser, type ChangePassword, type ResetPassword, type TotpPendingResponse, type UserModel } from '@models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private http = inject(HttpClient);

  login(email: string, password: string, totp?: string): Observable<AuthorizedUser | TotpPendingResponse> {
    return this.http.post<AuthorizedUser | TotpPendingResponse>('clients/v1/auth', { email, password, totp });
  }

  getProfile(): Observable<UserModel> {
    return this.http.get<UserModel>('clients/v2/users/profile');
  }

  forgotPassword(email: string) {
    return this.http.get('clients/v1/forgot-password', { params: { email } });
  }

  passwordRecovery(data: ResetPassword): Observable<ResetPassword> {
    return this.http.post<ResetPassword>('clients/v1/reset-password', data);
  }

  changePassword(data: ChangePassword) {
    return this.http.post<ChangePassword>('clients/v1/change-password', data);
  }
}
